import { useState, useEffect } from "react";
import { Grid, Tooltip, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useFormContext } from "react-hook-form";

const useStyles = makeStyles(() => ({
  tooltip: {
    display: "flex",
    alignItems: "center",
    fontStyle: "none",
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "none",
    }
  }
}))

const getTooltipVisibility = (answers) => {
  const {
    VORWURF,
    PLACE,
    TYPE_OF_VEHICLE,
    TEMPO,
  } = answers;

  if (VORWURF === "SPEEDING" && TYPE_OF_VEHICLE === "VEHICLE_ONLY") {
    if (TEMPO === "26_TO_30") {
      return true
    }

    if (TEMPO === "31_TO_40" && PLACE === "OUTER_CITY") {
      return true;
    }
  } else { 
    return false;
  }
}

const tooltipText = "Nur, wenn es innerhalb eines Jahres ein zweites Mal zu einer Geschwindigkeitsüberschreitung um mehr als 25 km/h kam.";

const SpeedingTooltip = () => {
  const classes = useStyles();
  const [showTooltip, setShowTooltip] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const { watch } = useFormContext();
  const values = watch();

  useEffect(() => {
    const isVisible = getTooltipVisibility(values);
    setIsTooltipVisible(isVisible);
  }, [values])

  return (
    isTooltipVisible ? (
      <>
        <Grid item xs={2} className={classes.tooltip}>
          <Tooltip
            title={tooltipText}
            open={showTooltip}
            placement="top"
            onOpen={() => setShowTooltip(true)}
            onClose={() => setShowTooltip(false)}
          >
            <Button
              color="primary"
              onClick={() => setShowTooltip(!showTooltip)}
            >
              Hinweis
            </Button>
          </Tooltip>
        </Grid>
      </>
    ) : null)
}

export default SpeedingTooltip;